import { render, staticRenderFns } from "./ReportTitleBand.vue?vue&type=template&id=01ad5e4a&"
import script from "./ReportTitleBand.vue?vue&type=script&lang=js&"
export * from "./ReportTitleBand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports